import React, { Component } from 'react';
import lodash from 'lodash';
import moment from 'moment';
import {
    PrimaryStepAction,
    StudyStepTitle,
    StudyStepInfoContainer,
} from 'pages/study/containers/components/StudyFormField';
import InputField from 'pages/study/containers/inputFields/inputFields';
import { getBinderEssentials } from 'pages/study/utils/studyUtils';

class StudyEssential extends Component {
    constructor(props){
        super(props);
        this.onValueChange = this.onValueChange.bind(this);
        this.onRemoveSelectedValue = this.onRemoveSelectedValue.bind(this);
        this.validate = this.validate.bind(this);
        this.renderStudyEssentials = this.renderStudyEssentials.bind(this);

        const essentialsMetadata = lodash.get(this.props, 'stepData.fields.studyEssentials', []);
        const initialEssentials = getBinderEssentials();
        const essentials = this.initEssentials(initialEssentials, essentialsMetadata);

        this.state = {
            essentials,
            initialEssentials,
            isValid : false,
        };
    }

    initEssentials(initialEssentials, essentialsMetadata) {
        return lodash.map(initialEssentials, initialEssential => {
            const metadata = lodash.find(
                essentialsMetadata,
                essential => essential.name === initialEssential.name);
            if (metadata) {
                initialEssential.value = metadata.value;
            }
            return initialEssential;
        });
    }

    onValueChange(id, value){

        let newStudyEssentials = lodash.clone(this.state.essentials);
        
        newStudyEssentials = this.updateStudyEssentialValue(id, value);
        this.updateAndValidateStudyEssential(newStudyEssentials);
    }

    updateAndValidateStudyEssential(newStudyEssentials){
        this.setState({essentials : newStudyEssentials}, () => {
            this.validate();
            this.props.setField('studyEssentials', this.state.essentials);
        });
    }

    onRemoveSelectedValue(selectedValue, id){
        const newStudyEssentials = lodash.clone(this.state.essentials);

        newStudyEssentials.map( studyRequirement => {
            if(studyRequirement.id === id){
                const updatedSelectedValue = lodash.without(studyRequirement.value, selectedValue);
                return studyRequirement.value = updatedSelectedValue;
            }
        });
        this.updateAndValidateStudyEssential(newStudyEssentials);
    }

    updateStudyEssentialValue(studyRequirementIdToReplace, newInput){
        const newStudyEssentials = lodash.clone(this.state.essentials);
        newStudyEssentials.find( (newStudyEssential) => {
            return newStudyEssential.name === studyRequirementIdToReplace;
        }).value = newInput;
        return newStudyEssentials;
    }

    validate(){
        const studyEssentials = lodash.get(this.state, 'essentials', []);
        const userInputValidation = studyEssentials.map( essential => {
            const { inputFieldType, value } = essential;
            const notEmptyString = value !=='' && /\S/.test(value);
            const hasValidString = notEmptyString && !lodash.isNil(value);

            const hasValueInDDL = !lodash.isEmpty(value) && !lodash.isNil(value);
            const hasValidDate = !lodash.isNil(value) && moment(value).isValid();
            const validationMapping = {
                'single-value' : hasValidString,
                'multi-line' : hasValidString,
                'date-value' : hasValidDate,
                'multi-select' : hasValueInDDL,
                'single-select' : hasValueInDDL
            };
            return validationMapping[inputFieldType];
        });
        
        this.setState({
            isValid: !userInputValidation.includes(false)
        });
    }
    componentDidMount(){
        this.validate();
    }

    completeStep() {
        this.props.setField('studyEssentials', this.state.essentials);
        return this.props.progressToNextStep(this.state);
        
    }

    renderStudyEssentials(){
        const { essentials } = this.state;
        return essentials.map((studyEssential, index) => {
            const autoFocusOnFirstElement = index === 0;
            const { name, inputFieldType, label, dataType } = studyEssential;
            const value = lodash.get(studyEssential, 'value', null);
            
            return(
                <InputField
                    id={name}
                    name={label}
                    value={value}
                    dataType={dataType} 
                    key={name}
                    targetId={name}
                    inputFieldType={inputFieldType} 
                    onValueChange={this.onValueChange} 
                    isAutoFocused={autoFocusOnFirstElement} 
                />
            );

        });
    }

    render(){
        const { stepData: { isDraft = false }, onExit } = this.props;
        return(
            <div>
                <StudyStepTitle>
                    Study Details
                </StudyStepTitle>
                <StudyStepInfoContainer>
                    <p>
                        These fields capture data points about the study based on the study type you selected.
                    </p>
                </StudyStepInfoContainer>
                <div>
                    {this.renderStudyEssentials()}
                    <PrimaryStepAction 
                        saveButtonText='Save and Continue'
                        exitButtonText={`Exit ${isDraft ? 'Draft' : 'Study'}`}
                        onClickSave={this.completeStep.bind(this)}
                        onClickExit={onExit}
                    />
                </div>
            </div>
        );
    }
}

export default StudyEssential;
